import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';

// Queries
import postAdminCarrito from '../Queries/postAdminCarrito';

// Styles
import styles from './index.module.sass';

export default function ConfigWhatsapp({ screenSize, setOpenModal, setregistradoEnWS }) {
  const { i18n = {} } = useTranslation();
  const { language = '' } = i18n;

  const [alertTextError, setAlertTextError] = useState('');
  const [alertTextSuccess, setalertTextSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [valuesForm, setvaluesForm] = useState({
    tel: '',
    codTel: '+1',
    codigo: '',
  });
  const [codigoValidacion, setcodigoValidacion] = useState(false);
  const [mensajeBoton, setmensajeBoton] = useState('Siguiente');

  const changeValue = (e) => {
    setvaluesForm({
      ...valuesForm,
      [e.target.name]: e.target.value,
    });
  };

  async function handleSubmit(e) {
    setLoading(true);
    setAlertTextError('');
    setalertTextSuccess('');
    const order = await postAdminCarrito({
      tmbservice: '/WebApiWhatsAppMXUS/api/Autentificacion/Verificacion',
      jsonBody: {
        telefono: valuesForm.codTel + valuesForm.tel,
        lenguaje: language,
      },
    });

    const { codigoMensaje, data } = order;

    // setSessionMessage(mensaje);

    if (codigoMensaje === 200) {
      if (data.status === 'pending' && data.valid === false) {
        setcodigoValidacion(true);
      } else {
        setcodigoValidacion(false);
        setmensajeBoton('Volver a enviar código');
        setAlertTextError(
          data.message || 'Ocurrio un error al validar tu información, intentalo nuevamente',
        );
      }
    } else {
      setAlertTextError('Ocurrio un error al validar tu información, intentalo nuevamente');
    }

    setLoading(false);
  }

  async function handleSubmitCodigo(e) {
    setLoading(true);

    const order = await postAdminCarrito({
      tmbservice: '/WebApiWhatsAppMXUS/api/Autentificacion/Validacion',
      jsonBody: {
        telefono: valuesForm.codTel + valuesForm.tel,
        lenguaje: language,
        codigo: valuesForm.codigo,
        Lugar: valuesForm.codTel === '+1' ? 'Estados Unidos' : 'México',
      },
    });

    const { codigoMensaje, mensajeEsp, data } = order;

    // setSessionMessage(mensaje);

    if (codigoMensaje === 200) {
      if (data.status === 'approved' && data.valid === true) {
        setalertTextSuccess('Tú Whatsapp se ha validado exitosamente');
      } else {
        setAlertTextError('Ocurrio un error con el código de validacion, envialo nuevamente');
        setcodigoValidacion(false);
      }
    } else {
      setAlertTextError(
        mensajeEsp || 'Ocurrio un error con el código de validacion, envialo nuevamente',
      );
      setcodigoValidacion(false);
    }

    setLoading(false);
  }

  function cerrarModal() {
    setregistradoEnWS(true);
    setOpenModal(false);
  }

  return (
    <div className={styles.formWS}>
      {alertTextError !== '' && (
        <div className={styles.alertasValidacion}>
          <Alert severity='error'>{alertTextError}</Alert>
        </div>
      )}

      {alertTextSuccess !== '' && (
        <div className={styles.alertasValidacion}>
          <Alert severity='success'>{alertTextSuccess}</Alert>
        </div>
      )}

      <div className={styles.titleNotificaciones}>¿A qué número enviamos las notificaciones?</div>
      <div className={styles.celWS}>
        <div>
          <select
            className={styles.inputSelect}
            onChange={(e) => changeValue(e)}
            name='codTel'
            value={valuesForm.codTel}>
            <option value='+1'>🇺🇸 +1</option>
            <option value='+52'>🇲🇽 +52</option>
          </select>
        </div>
        <div>
          <input
            type='tel'
            className={`${styles.textNumber} ${styles[screenSize]}`}
            maxLength={10}
            pattern='[0-9]{10}'
            onChange={(e) => changeValue(e)}
            name='tel'
            value={valuesForm.tel}
          />
        </div>
      </div>

      {/* <div>¿En que idioma deseas que te notifiquemos?</div>
      <div>
        <select
          className={styles.inputSelect}
          onChange={(e) => changeValue(e)}
          name='idioma'
          value={valuesForm.idioma}>
          <option value='es'>Español</option>
          <option value='en'>Ingles</option>
        </select>
      </div> */}
      <div className={styles.indicaciones}>Ingresa el número asociado a tu cuenta de WhatsApp.</div>

      {codigoValidacion === true ? (
        <>
          <div>Ingresa el código que recibiste por whatsapp</div>
          <div>
            <input
              type='text'
              className={`${styles.textNumberCod} ${styles[screenSize]}`}
              onChange={(e) => changeValue(e)}
              name='codigo'
              value={valuesForm.codigo}
            />
          </div>
          <div className={styles.button}>
            <Button
              type='submit'
              variant='contained'
              size='large'
              color='primary'
              className={(loading && styles.disabled) || styles.actionButton}
              onClick={handleSubmitCodigo}
              disabled={loading}>
              {(loading && <CircularProgress className={styles.circularProgress} />) ||
                'Validar mi código'}
            </Button>
          </div>
        </>
      ) : (
        <div className={styles.buttons}>
          <div>
            <Button
              type='submit'
              variant='contained'
              size='large'
              color='primary'
              className={(loading && styles.disabled) || styles.actionButton}
              onClick={handleSubmit}
              disabled={loading}>
              {(loading && <CircularProgress className={styles.circularProgress} />) ||
                mensajeBoton}
            </Button>
          </div>

          <div>
            <Button
              type='button'
              variant='contained'
              size='large'
              color='primary'
              className={styles.cerrarModal}
              onClick={() => cerrarModal()}
              disabled={loading}>
              No quiero recibir notificaciones
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
